import { render } from "./GeneralEdit.vue?vue&type=template&id=c1ad4128&scoped=true"
import script from "./GeneralEdit.vue?vue&type=script&lang=js"
export * from "./GeneralEdit.vue?vue&type=script&lang=js"

import "./GeneralEdit.vue?vue&type=style&index=0&id=c1ad4128&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1ad4128"]])

export default __exports__